import { Elements, FlowElement } from "react-flow-renderer";
import { Store } from "react-stores";
import { SPLToken } from "../interfaces";
import { getConstants } from "../config/constants";
import { PublicKey, Signer } from "@solana/web3.js";
import { u64 } from "@solana/spl-token";
import { TokenInfo } from "@solana/spl-token-registry";
import { utils as splUtils } from "@malloc-protocol/spl";
import { Awaited, Unpacked } from "../utils/types";

export type RaydiumLiquidityPool = Unpacked<
  Awaited<ReturnType<typeof splUtils.raydium.getMainnetRaydiumPools>>
>;

export interface IFlowChart {
  elements: Elements<any>;
  initSplits: number[];
  initTokenAccount?: PublicKey;
  initAmount: u64;
}

export interface SolanaConstants {
  derivedTokenAccounts: SPLToken[] | null;
  tokenList: TokenInfo[] | null;
  raydium: {
    liquidityPools: RaydiumLiquidityPool[] | null;
  };
}

export const solanaConstantsStore = new Store<SolanaConstants>({
  derivedTokenAccounts: null,
  tokenList: null,
  raydium: { liquidityPools: null },
});
